// For show more btn in hm-horizontal-products
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.hm-horizontal-products');

  sections.forEach(function(section) {
    const items = section.querySelectorAll('.grid__item, .slider__slide');
    if (!items.length || items.length <= 4) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hm-show-more-btn';
    btn.textContent = 'Show More';

    items.forEach(function(item, index) {
      if (index > 3) item.classList.add('hm-mobile-hidden');
    });

    section.appendChild(btn);

    btn.addEventListener('click', function() {
      section.classList.toggle('hm-expanded');

      if (section.classList.contains('hm-expanded')) {
        btn.textContent = 'Show Less';
      } else {
        btn.textContent = 'Show More';
      }
    });
  });
});